import { Component, Input } from '@angular/core';

@Component({
  selector: 'om-svg-pill',
  template: `
    <svg [attr.width]="width" [attr.height]="height" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.98669 10.09C2.59144 7.67335 3.41944 4.58318 5.8361 3.18793C8.25276 1.79267 11.3429 2.62068 12.7382 5.03733L15.2809 9.44149L6.52944 14.4942L3.98669 10.09Z"
        [attr.fill]="backgroundColor"
        [attr.fill-opacity]="backgroundOpacity"
        [attr.stroke]="color"
      />
      <path
        d="M17.861 13.91C19.2562 16.3266 18.4282 19.4168 16.0116 20.8121C13.5949 22.2073 10.5047 21.3793 9.10947 18.9627L6.56673 14.5585L15.3182 9.50584L17.861 13.91Z"
        [attr.fill]="backgroundColor"
        [attr.fill-opacity]="backgroundOpacity"
        [attr.stroke]="color"
      />
      <path
        d="M11.8017 15.0856C12.0101 15.4466 11.8864 15.9054 11.5293 16.1116C11.1722 16.3178 10.7129 16.1955 10.5045 15.8346C10.2961 15.4736 10.4198 15.0147 10.7769 14.8085C11.134 14.6024 11.5933 14.7247 11.8017 15.0856Z"
        [attr.fill]="color"
        [attr.stroke]="color"
      />
      <path
        d="M15.5986 16.109C15.807 16.47 15.6832 16.9289 15.3261 17.1351C14.969 17.3412 14.5098 17.2189 14.3014 16.858C14.093 16.497 14.2167 16.0382 14.5738 15.832C14.9309 15.6258 15.3902 15.7481 15.5986 16.109Z"
        [attr.fill]="color"
        [attr.stroke]="color"
      />
    </svg>
  `,
})
export class SvgPillComponent {
  @Input() color = '#000';
  @Input() backgroundColor = '#FFF';
  @Input() backgroundOpacity = 1;
  @Input() width = '100%';
  @Input() height = '100%';
}
